<template>
  <div>
    <template v-if="images.length > 2">
      <div class="amp-carousel theme-base-bg-color">
        <div class="amp-img-sizer" :style="'padding-top:' + images[0].height / images[0].width * 100 + '%'"></div>
        <div :class="['amp-carousel-slide-container', isSet ? 'is-set' : '']">
          <template v-for="(image, i) in images">
            <div class="amp-carousel-item" :style="'order: ' + orders[i]">
              <mimic-amp-img :image="image"></mimic-amp-img>
            </div>
          </template>
        </div>
      </div>
    </template>
    <template v-else-if="images.length === 0">
      <div class="component-warning flex justify-center items-center">
        <span class="component-warning-span">カルーセル用の画像が選択されていません</span>
      </div>
    </template>
    <template v-else>
      <div class="component-warning flex justify-center items-center">
        <span class="component-warning-span">カルーセルのために３枚以上の画像を選択してください</span>
      </div>
    </template>
  </div>
</template>

<script>
import MimicAmpImg from './MimicAmpImg'

export default {
  name: 'mimic-amp-carousel',
  components: {
    'mimic-amp-img': MimicAmpImg
  },
  props: ['images', 'delay'],
  data: function () {
    return {
      timerId: null,
      orders: [],
      isSet: true
    }
  },
  methods: {
    updateOrders: function () {
      this.orders = this.images.map((image, i) => ((i + 1) % this.images.length) + 1)
    }
  },
  watch: {
    images: function (newVal, oldVal) {
      this.updateOrders()
    },
    delay: function (newVal, oldVal) {
      if (this.delay < 1000) return
      clearInterval(this.timerId)
      this.timerId = setInterval(() => {
        this.orders.unshift(this.orders.splice(this.orders.length - 1, 1))
        this.isSet = false
        setTimeout(() => { this.isSet = true }, 50)
      }, this.delay)
    }
  },
  created: function () {
    this.updateOrders()
  },
  mounted: function () {
    this.timerId = setInterval(() => {
      this.orders.unshift(this.orders.splice(this.orders.length - 1, 1))
      this.isSet = false
      setTimeout(() => { this.isSet = true }, 50)
    }, this.delay)
  },
  beforeDestroy: function () {
    clearInterval(this.timerId)
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

.amp-carousel {
  overflow: hidden;
  position: relative;
  &-slide-container {
    display: flex;
    flex-wrap: nowrap;
    box-sizing: content-box;
    padding-bottom: 20px;
    width: 100%;
    height: 100%;
    // overflow-x: auto;
    // overflow-y: hidden;
    position: absolute;
    top: 0;
    left: 0;
    left: -100%;
    transform: translateX(100%);
    scroll-snap-type: mandatory;
    &.is-set {
      transform: none;
      transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1);
    }
  }
  &-item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 100%;
    width: 100%;
    height: 100%;
    position: relative;
    scroll-snap-coordinate: 0 0;
    & > * {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  }
}
.component-warning {
  padding: 5em 0;
  background-color: #fafafa;
  &-span {
    color: red;
  }
}
</style>

<doc>
https://blog.madewithenvy.com/the-order-property-flexbox-carousels-87a168567820
</doc>


// WEBPACK FOOTER //
// src/components/mimic-amp/MimicAmpCarousel.vue